/*
 * EmsChallengeFriend Messages
 *
 * This contains all the text for the EmsChallengeFriend component.
 */
import { defineMessages } from 'react-intl';
import { fieldNames } from './model';

export default defineMessages({
  [fieldNames.email]: {
    id: 'graphql.EmsChallengeFriend.email',
    defaultMessage: 'Email id of your friend',
  },
  title: {
    id: 'graphql.EmsChallengeFriend.title',
    defaultMessage: 'Challenge a friend',
  },
  submitButton: {
    id: 'graphql.EmsChallengeFriend.submitButton',
    defaultMessage: 'Challenge Now',
  },
});
